/**
 * Experimental declarative router solution
 */

import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['errors', 'success']),
        ...mapGetters(['isBooking', 'isExternalBooking', 'isNoBooking', 'isBookableHotelVoucher', 'hasVoucher', 'voucherCode', 'isOrderMode']),
        showBookingDetails() {
            return (this.isBooking || this.isExternalBooking || this.isNoBooking || this.isBookableHotelVoucher);
        },
        showVoucherStatus() {
            return this.hasVoucher && !this.isBookableHotelVoucher;
        }
    },
    watch: {
        showBookingDetails(showBookingDetails) {
            if (showBookingDetails) {
                if (this.$route.query && this.$route.query.token) {
                    this.$router.push({ name: 'BookingDetails', query: { code: this.voucherCode, token: this.$route.query.token } });
                } else {
                    this.$router.push({ name: 'BookingDetails', query: { code: this.voucherCode } });
                }
            }
        },
        showVoucherStatus(showVoucherStatus) {
            if (showVoucherStatus) {
                this.$router.push({ name: 'VoucherStatus' });
            }
        },
        hasVoucher(hasVoucher) {
            if (!hasVoucher) {
                this.$router.push('/');
            }
        },
        success(success) {
            if (success) {
                this.$router.replace({ name: 'BookingSuccess' });
            }
        }
    },
};
